import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
} from '@angular/core';
import { RdsBadgeModule, RdsButtonModule } from '@rds/angular-components';

import { RouterLink } from '@angular/router';
import { StoryblokOffering } from '../../../models/storyblok-offering.model';
import { MulesoftOffering } from '../../../models/mulesoft-offering';
import { FaroActionDirective } from '../../../directives/faro-action.directive';
import { FeatureFlagDirective } from '../../../directives/feature-flag.directive';
import {
  canDownloadOffering,
  OfferingDownloadComponent,
} from '../offering-download/offering-download.component';

@Component({
  selector: 'inexp-offering-hero',
  imports: [
    RdsButtonModule,
    RdsBadgeModule,
    RouterLink,
    FaroActionDirective,
    FeatureFlagDirective,
    OfferingDownloadComponent,
  ],
  templateUrl: './offering-hero.component.html',
  styleUrl: './offering-hero.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OfferingHeroComponent {
  _uid = input<string>();
  component = input<string>();
  displayName = input<string>();
  description = input<string>();
  offeringImage = input<string>();
  imageAltText = input<string>();
  approvalStatus = input<string>();
  offeringType = input<string>();
  tags = input<string[]>([]);
  licenseCostResponsibility = input<string>();
  callToAction = input<string>();
  successor = input<StoryblokOffering>();
  relationshipType = input<string>();
  relationshipTarget = input<StoryblokOffering>();

  /**
   * The full Process API record, supplied only by `mulesoft-offering.mapper`.
   *
   * Every other input here is a flattened field, because that is all the hero
   * renders. The factsheet is the exception: it serialises the whole offering,
   * so it needs the record rather than a projection of it. The Storyblok render
   * path leaves this undefined, which is what keeps the button off that page.
   */
  offering = input<MulesoftOffering>();

  /**
   * Whether to render the factsheet row at all.
   *
   * Asked here rather than left to the button, because the row is a flex item
   * in a `gap`-spaced column: a wrapper holding a button that renders nothing
   * would still hold 20px of space open under the tags.
   */
  readonly canDownloadFactsheet = computed(() =>
    canDownloadOffering(this.offering()),
  );

  navigate() {
    window.open(this.callToAction(), '_blank');
  }

  scrollTo(id: string) {
    const el = document.getElementById(id);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      const { pathname, search } = window.location;
      history.replaceState(null, '', `${pathname}${search}#${id}`);
    }
  }

}
